/**
 * Function that computes if the first array of attributes is a prefix of the second array.
 *
 * @param prefixAttributes array of attributes in a variant key
 * @param variantKeyAttributes array of attributes in a variant key
 * @param matchWildcards Should the wildcard character "*" be interpreted as a match
 * @returns the length of the matched prefix or -1 if `prefixAttributes` is not a prefix of `variantKeyAttributes`
 */
export function getVariantKeyPrefixLength(
  prefixAttributes: string[],
  variantKeyAttributes: string[],
  matchWildcards = false
) {
  let wildcardMatches = 0
  for (let i = 0; i < prefixAttributes.length; i += 1) {
    const isMatch = variantKeyAttributes[i] === prefixAttributes[i]
    const isWildcardMatch =
      matchWildcards &&
      (prefixAttributes[i] === "*" || variantKeyAttributes[i] === "*")

    if (isWildcardMatch) {
      wildcardMatches += 1
    }
    if (!isMatch && !isWildcardMatch) {
      return -1
    }
  }
  return prefixAttributes.length - wildcardMatches
}
